<template>
    <div v-if="selectedOption" class="your-selection p-4">
        <strong
            >You have <span>{{ isAddition ? "selected" : "deselected" }}</span
            >:</strong
        >
        <hr />
        <div class="option d-flex justify-content-between">
            <!-- eslint-disable-next-line vue/no-v-html -->
            <div
                class="label d-flex flex-column justify-content-center"
                v-html="getName(selectedOption)"
            />
            <div class="cost">
                {{ getCost(selectedOption) | numeral("$0,0") }}
            </div>
        </div>
    </div>
</template>

<style lang="scss">
.your-selection {
    background-color: $very-light-gray;
    border-radius: 8px;

    hr {
        color: $light-gray;
    }

    .cost {
        color: $primary-blue;
        font-family: $helvetica-45-light;
        font-size: 24px;
    }

    strong {
        font-family: $helvetica-65-medium;
        font-weight: normal;

        > span {
            color: $primary-blue;
        }
    }
}
</style>

<script>
import modals from "Modules/Configure/mixins/modals";
import { get } from "vuex-pathify";

export default {
    mixins: [modals],

    computed: {
        selectedOption: get("configure/originatingChromeOption")
    }
};
</script>
